import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/** Browser tab title "PMAI – <page or entity>" (FR-NAV-008). */
export function useDocumentTitle(title: string | undefined): void {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = title ? `${t('app.name')} – ${title}` : t('app.name');
  }, [title, t]);
}
